import request from '../request'

export function fetchDesignPlanDetail(id) {
    return request({
        url: `/project-service/cosys/design/plan/detail/${id}`,
        method: 'get',
    })
}

export function resubmitDesignPlan(data) {
    return request({
        url: '/project-service/cosys/design/plan/resubmit',
        method: 'post',
        data
    })
}

/**
 * 根据阶段ID获取计划版本信息
 * @param {string|number} phaseId - 阶段ID
 */
export function fetchDesignPlanVersionInfo(phaseId) {
    return request({
        url: `/project-service/cosys/design/plan/versionInfo/${phaseId}`,
        method: 'GET'
    })
}